module.exports = __webpack_public_path__ + "img/thumbs-up-gray.743fe6ca.svg";